import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiDashboardService {
  url: string = environment.api_dashboard.base_url;

  constructor(private http: HttpClient) {}

  // Método GET con headers y query parameters opcionales
  getData(endpoint: string, headersObj?: any, queryParamsObj?: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      ...headersObj,
    });

    let params = new HttpParams();
    if (queryParamsObj) {
      for (const key in queryParamsObj) {
        if (queryParamsObj.hasOwnProperty(key)) {
          params = params.set(key, queryParamsObj[key]);
        }
      }
    }

    return this.http.get<any>(`${this.url}/${endpoint}`, { headers, params }).pipe(
      map(response => response),
      catchError(this.handleError)
    );
  }

  // Método POST con headers, body y query parameters opcionales
  postData(endpoint: string, body: any, headersObj?: any, queryParamsObj?: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      ...headersObj,
    });

    let params = new HttpParams();
    if (queryParamsObj) {
      for (const key in queryParamsObj) {
        if (queryParamsObj.hasOwnProperty(key)) {
          params = params.set(key, queryParamsObj[key]);
        }
      }
    }

    return this.http.post<any>(`${this.url}/${endpoint}`, body, { headers, params }).pipe(
      map(response => response),
      catchError(this.handleError)
    );
  }

  // Método PUT con headers, body y query parameters opcionales
  putData(endpoint: string, body: any, headersObj?: any, queryParamsObj?: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      ...headersObj,
    });

    let params = new HttpParams();
    if (queryParamsObj) {
      for (const key in queryParamsObj) {
        if (queryParamsObj.hasOwnProperty(key)) {
          params = params.set(key, queryParamsObj[key]);
        }
      }
    }

    return this.http.put<any>(`${this.url}/${endpoint}`, body, { headers, params }).pipe(
      map(response => response),
      catchError(this.handleError)
    );
  }

  // Método privado para manejar errores
  private handleError(error: any): Observable<never> {
    console.error('Ocurrió un error:', error);
    return throwError('Algo salió mal; por favor intente de nuevo más tarde.');
  }
}
